import styled from 'styled-components';
import { CardSectionMixin } from '../../mixins/components/CardSectionMixin';

/**
 * @since 4.1.0
 */

var CardSection = /*#__PURE__*/styled.section.withConfig({
  displayName: "CardSection",
  componentId: "c11n-8-107-0__sc-10rcp1p-0"
})(["", ""], CardSectionMixin);
CardSection.displayName = 'CardSection';

/** @component */
export { CardSection };